module.exports = __webpack_public_path__ + "img/logo-text-min.31203def.svg";